import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/logistic-agent/new',
  title: 'Cadastrar Motoboy',
  endpoint: '/app/person',
}
